import * as actions from "../actions_agent/Type";
const intialState = {
  list_sell_fromto: [],
  list_rent_fromto: [],
};
const RaportReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.SELL_FROMTO_RAPORT:
      return {
        ...state,
        list_sell_fromto: action.payload,
      };
    case actions.RENT_FROMTO_RAPORT:
      return {
        ...state,
        list_rent_fromto: action.payload,
      };
    default:
      return { ...state };
  }
};

export default RaportReducer;
